import React, { useCallback, useState } from "react";
import { Link, Redirect } from "react-router-dom";
import { signOut } from "@culturehq/client";
import { Button } from "@culturehq/components";

import { useProfile } from "app/context";
import { defaultProfile } from "app/context/ProfileContext";
import { useAsyncAction, useEnterPress } from "app/hooks";
import { Trans, errorService } from "app/utils";

import styles from "./logout.module.scss";

const Logout = () => {
  const { fetchedProfile } = useProfile();
  const [redirect, setRedirect] = useState(false);

  const { onTrigger: onLogout } = useAsyncAction(
    useCallback(
      async () => {
        await signOut();
        setRedirect(true);
        fetchedProfile(defaultProfile);
        window.location.reload();
      },
      [fetchedProfile, setRedirect]
    )
  );

  useEnterPress(onLogout);

  if (redirect) {
    errorService.log("Redirect to login, logout");
    return <Redirect to="/login" />;
  }

  return (
    <div className={styles.logout}>
      <p>
        <Trans>Are you sure you want to sign out?</Trans>
      </p>
      <p>
        <Button fillParent primary onClick={onLogout}>
          <Trans>Sign Out</Trans>
        </Button>
      </p>
      <p>
        <Link to="/">
          <Trans>Return home</Trans>
        </Link>
      </p>
    </div>
  );
};

export default Logout;
